import type { ScheduleSlotDto } from "../web-api-client";

export type SlotStatusOC = "O" | "C";

export function normalizeStatusOC(status: any): SlotStatusOC {
  if (status === "C" || status === 1) return "C";
  return "O";
}

export function buildUpdateSchedulePayload(
  slot: ScheduleSlotDto,
  patch: Partial<{ capacity: number; status: "O" | "C" }>
) {
  const capacity = patch.capacity ?? (slot.capacity ?? 1); // validator yêu cầu >0
  const status = patch.status ?? normalizeStatusOC(slot.status);

  return {
    id: slot.id!,
    capacity,
    status,
  };
}